import {message, FormatXMLElementFn} from '@sail/intl';

export const sectionCaption = message({
  id: 'mkt-ssr.startup_partners.why_stripe.section_caption',
  defaultMessage: 'Why Stripe',
  description: 'Caption for the Why Stripe section',
});

export const sectionTitle = message({
  id: 'mkt-ssr.startup_partners.why_stripe.section_title',
  defaultMessage: 'The complete financial stack for startups',
  description: 'Title for the Why Stripe section',
});

export const getStartedTitle = message({
  id: 'mkt-ssr.startup_partners.why_stripe.get_started_title',
  defaultMessage: 'Everything you need to get started fast',
  description: 'Title for the getting started subsection',
});

export const getStartedBody = message<{
  paymentLinksLink: FormatXMLElementFn;
  invoicingLink: FormatXMLElementFn;
}>({
  id: 'mkt-ssr.startup_partners.why_stripe.get_started_body',
  defaultMessage:
    'The best way to test customer willingness to pay and find product market fit with <paymentLinksLink>Stripe Payment Links</paymentLinksLink> and <invoicingLink>Stripe Invoicing</invoicingLink>. These two hosted payment options enable you to accept one click payments or get paid via Email.',
  description:
    'Description for the getting started subsection, with links to Payment Links and Invoicing',
});

export const growBusinessTitle = message({
  id: 'mkt-ssr.startup_partners.why_stripe.grow_business_title',
  defaultMessage: 'Grow your business with Stripe',
  description: 'Title for the growing business subsection',
});

export const growBusinessBody = message({
  id: 'mkt-ssr.startup_partners.why_stripe.grow_business_body',
  defaultMessage:
    'No matter your business model—SaaS, direct-to-consumer ecommerce, platform, marketplace—the Stripe platform applies intelligent optimizations based on billions in transactions to help block fraud and maximize revenue.',
  description: 'Description for the growing business subsection',
});

export const globalBenefitTitle = message({
  id: 'mkt-ssr.startup_partners.whystripe.benefits.global.title',
  defaultMessage: 'Go global with Stripe',
  description: 'Title for the 2nd benefit of using Stripe.',
});

export const globalBenefitDescription = message({
  id: 'mkt-ssr.startup_partners.whystripe.benefits.global.description',
  defaultMessage:
    'Launch new markets, currencies, and payment methods—with minimal changes to your code. Stripe handles all cross-border money movement and currency conversion so you and your users receive payouts in your local currency.',
  description: 'Description for the 2nd benefit of using Stripe.',
});

export const suiteBenefitTitle = message({
  id: 'mkt-ssr.startup_partners.whystripe.benefits.suite.title',
  defaultMessage: 'Do more with the full suite',
  description: 'Title for the 4th benefit of using Stripe.',
});

export const suiteBenefitDescription = message<{
  RadarLink: FormatXMLElementFn;
  TaxLink: FormatXMLElementFn;
  IdentityLink: FormatXMLElementFn;
  SigmaLink: FormatXMLElementFn;
}>({
  id: 'mkt-ssr.startup_partners.whystripe.benefits.suite.description.line1',
  defaultMessage:
    'Set up advanced <RadarLink>fraud protection</RadarLink>, <TaxLink>automate tax and VAT calculation</TaxLink>, <IdentityLink>verify identities</IdentityLink>, <SigmaLink>analyze business data</SigmaLink>, increase conversion, mitigate churn, and much more.',
  description: 'Description for the 4th benefit of using Stripe.',
});
